import { format as e, setDay as t } from "date-fns";

import { times as a } from "lodash";

import { object as o, boolean as l } from "yup";

const i = {
    new: "New Patient",
    follow_up: "Follow-Up"
}, r = {
    ...i,
    available: "Available"
}, n = {
    week: "Week",
    month: "Month"
}, s = Object.entries(n).map((([e, t]) => ({
    label: t,
    value: e
}))), p = "MM-dd-yyyy", b = "hh:mmaaa", m = 0, u = {
    available: "Available Slots",
    upcomingVisits: "Upcoming Visits",
    pastVisits: "Past Visits"
}, c = Object.entries(u).reduce(((e, [t, a]) => e.concat(o({
    [t]: l().label(a).required().default(!0).nullable()
}))), o()), y = e => e?.booked ? e.bookingType : "available", f = a(7, (a => e(t(new Date, a), "eee"))), d = e => {
    if (!e) return "";
    const {frequency: t, interval: a} = e;
    return "WEEKLY" === t ? "number" == typeof a && {
        1: "Weekly",
        2: "Every other week"
    }[a] || "" : "Does not repeat";
};

export { i as BOOKING_SLOT_TYPES, u as PROVIDER_SCHEDULE_SLOTS_FILTERS, p as SCHEDULE_DATE_FORMAT, r as SCHEDULE_SLOT_TYPES, b as SCHEDULE_TIME_FORMAT, m as SCHEDULE_WEEK_STARTS_ON, c as SlotsFiltersSchema, s as calendarViewModeOptions, n as calendarViewModes, f as calendarWeekDays, d as getScheduleIntervalTitle, y as getSlotType };
//# sourceMappingURL=utils.js.map
